import { createBrowserRouter, Navigate } from "react-router";
import { lazy } from "react";
import { AuthGuard } from "./components/AuthGuard";
import { AuthProvider } from "./contexts/AuthProvider";

const ErrorBoundary = lazy(() =>
  import("./components/ErrorBoundary").then(({ ErrorBoundary }) => ({
    default: ErrorBoundary,
  }))
);

const Campaign = lazy(() =>
  import("./pages/Campaign").then(({ Campaign }) => ({
    default: Campaign,
  }))
);

const CampaignDetail = lazy(() =>
  import("./pages/CampaignDetail").then(({ CampaignDetail }) => ({
    default: CampaignDetail,
  }))
);

const CampaignDevelopment = lazy(() =>
  import("./pages/CampaignDevelopment").then(({ CampaignDevelopment }) => ({
    default: CampaignDevelopment,
  }))
);

const Brand = lazy(() =>
  import("./pages/Brand").then(({ Brand }) => ({
    default: Brand,
  }))
);

const Kol = lazy(() =>
  import("./pages/Kol").then(({ Kol }) => ({
    default: Kol,
  }))
);

const KolDetail = lazy(() =>
  import("./pages/KolDetail").then(({ KolDetail }) => ({
    default: KolDetail,
  }))
);

const ApiKey = lazy(() =>
  import("./pages/ApiKey").then(({ ApiKey }) => ({
    default: ApiKey,
  }))
);

const Topic = lazy(() =>
  import("./pages/Topic").then(({ Topic }) => ({
    default: Topic,
  }))
);

const router = createBrowserRouter([
  {
    element: (
      <AuthProvider>
        <AuthGuard />
      </AuthProvider>
    ),
    errorElement: <ErrorBoundary />,
    children: [
      { path: "/", Component: Campaign },
      { path: "/campaigns/:campaignId", Component: CampaignDetail },
      {
        path: "/campaigns/:campaignId/development",
        Component: CampaignDevelopment,
      },
      { path: "/kols", Component: Kol },
      { path: "/kols/:kolId", Component: KolDetail },
      { path: "/brands", Component: Brand },
      { path: "/topics", Component: Topic },
      { path: "/api-key", Component: ApiKey },
      { path: "*", element: <Navigate to="/" replace /> },
    ],
  },
]);

export { router };
